// extracted by css-extract-rspack-plugin
export default {"expandingAreaLabel":"_bebdb7b5","optionContainer":"_294668a6","expandingArea":"_57581313"};